import { render, staticRenderFns } from "./customDiaolg.vue?vue&type=template&id=b31feb0c"
import script from "./customDiaolg.vue?vue&type=script&lang=js"
export * from "./customDiaolg.vue?vue&type=script&lang=js"
import style0 from "./customDiaolg.vue?vue&type=style&index=0&id=b31feb0c&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports